var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15789 11.1632H10.4316V10.5737H4.15789V11.1632ZM4.15789 8.32105H13.8421V7.73158H4.15789V8.32105ZM4.15789 5.47895H13.8421V4.88947H4.15789V5.47895ZM1 17.2263V3.58421C1 3.06884 1.17291 2.63824 1.51874 2.29242C1.86442 1.94659 2.29502 1.77368 2.81053 1.77368H15.1895C15.7048 1.77368 16.1354 1.94659 16.4813 2.29242C16.8271 2.63824 17 3.06884 17 3.58421V12.5105C17 13.026 16.8271 13.4566 16.4813 13.8023C16.1354 14.1481 15.7048 14.3211 15.1895 14.3211H3.90526L1 17.2263ZM3.44211 13.1842H15.1895C15.3579 13.1842 15.5123 13.114 15.6526 12.9737C15.793 12.8333 15.8632 12.6789 15.8632 12.5105V3.58421C15.8632 3.41579 15.793 3.2614 15.6526 3.12105C15.5123 2.9807 15.3579 2.91052 15.1895 2.91052H2.81053C2.64211 2.91052 2.48772 2.9807 2.34737 3.12105C2.20702 3.2614 2.13684 3.41579 2.13684 3.58421V14.5105L3.44211 13.1842Z",
    fill: "#172B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.daa5e6b52ff96dbc5e011b1423999ebe.svg";
export { ForwardRef as ReactComponent };